import { Component } from '@angular/core';

@Component({
  selector: 'app-cartographie',
  standalone: true,
  imports: [],
  templateUrl: './cartographie.component.html',
  styleUrl: './cartographie.component.scss'
})
export class CartographieComponent {

}
